import {NotFoundHeader} from "@ohya/ohya-libs";
import React from "react";
import { useNavigate } from "react-router-dom";

const mainDomain = process.env.REACT_APP_GROUP_URL || "https://www.ohyagroup.com";

export const NotFound = (): JSX.Element => {
  const navigate = useNavigate();
  const navTo = (path: string) => {
    if (path === "/") window.location.assign(mainDomain + path);
    else navigate(path);
  };

  return (
    <>
      <div className="bg-[#eef8f6] flex justify-center items-center w-full h-screen z-[1]">
        <div className="bg-primaryprimary-25 w-[360px]">
          <div className="inline-flex flex-col items-center gap-[16px]">
            <img
              alt="Element error ohpasha"
              className="w-[188px] h-[170px] object-cover"
              src="/assets/images/404/404-error-ohpasha-2.gif"
            />
            <p className="relative w-fit mt-[-1.00px] [font-family:'Noto_Sans_TC',Helvetica] font-normal text-primaryprimary-700 text-[36px] text-center tracking-[0] leading-[36px]">
              <span className="font-[number:var(--36-d1-font-weight)] leading-[var(--36-d1-line-height)] font-36-d1 [font-style:var(--36-d1-font-style)] tracking-[var(--36-d1-letter-spacing)] text-[length:var(--36-d1-font-size)]">
                404
                <br />
              </span>
              <span className="font-[number:var(--24-h1-font-weight)] text-[length:var(--24-h1-font-size)] font-24-h1 [font-style:var(--24-h1-font-style)] tracking-[var(--24-h1-letter-spacing)] leading-[var(--24-h1-line-height)]">
                Page Not Found
              </span>
            </p>
            <div className="relative w-fit font-16-h3 font-[number:var(--16-h3-font-weight)] text-primaryprimary-700 text-[length:var(--16-h3-font-size)] text-center tracking-[var(--16-h3-letter-spacing)] leading-[var(--16-h3-line-height)] whitespace-nowrap [font-style:var(--16-h3-font-style)]">
              很抱歉，我們找不到該頁面，請前往歐悅首頁。
            </div>
            <button onClick={() => navTo("/")}>
              <div
                className="w-36 h-12 px-12 py-3 bg-[#88CCC3] rounded 
      hover:bg-[#60BBAD]
      justify-center items-center gap-2.5 inline-flex"
              >
                <div className="text-center text-white text-base font-medium font-['Noto Sans TC'] leading-normal">
                  回首頁
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div className="fixed top-0 left-0 right-0 z-10 bg-[white]">
        <NotFoundHeader />
      </div>
    </>
  );
};
